import { Icon } from '@seeqdev/qomponents';

interface RemovableTextButtonProps {
  label?: string;
  showFormat?: boolean;
  onClick?: () => void;
}

/**
 * Displays a close 'x' icon on text buttons that indicates that the text button can be removed. An example is in the
 * home screen search results.
 */
export const RemovableTextButton = ({ label, showFormat, onClick }: RemovableTextButtonProps) => {
  return (
    <div>
      {' '}
      {label}
      {showFormat && (
        <Icon icon="fa-close" type="text" onClick={onClick} testId="textButtonRemove" extraClassNames="tw:ml-2.5" />
      )}
    </div>
  );
};
